<template>
  <tr>
    <td align="left" width="150"> {{ file.type_display }} </td>
    <td :class='label'>{{ file.name }}</td>
    <td>{{ description }}</td>
    <td style='white-space: nowrap;' class='text-right' v-if="file !== null">
      <v-btn icon @click='downloadFile'>
        <v-icon>mdi-eye</v-icon>
      </v-btn>
      <v-btn v-if='send_file_enabled' icon @click='show_send=true'>
      <v-icon>mdi-mail</v-icon>
      </v-btn>
      <v-btn v-if='!disabled' icon @click='openRemoveModal'>
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <wc-confirm-dialog
        width='400'
        :showDialog='show_send'
        saveText='Send'
        icon='mdi-alert'
        iconColor='info'
        saveColor='info'
        title='Send File'
        @confirm='sendFile'
        @cancel='show_send=false'>
        <p> Are you sure you want to send this file?</p>
      </wc-confirm-dialog>

    </td>
  </tr>
</template>
<script>
import WCConfirmDialog from '@/components/dialogs/WCConfirmDialog';

export default {
  name: 'ci-file',
  props: {
    file: {
      required: true
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    send_file_enabled: {
        required: false,
        type: Boolean,
        default: false
    },
    show_description: {
        required: false,    
        default: false,
        type: Boolean
    },
    description: {
        required: false,
        default: "",
        type: String
    }
  },
  data: () => ({
    label: 'grey--text text-left',
    show_send: false,
  }),
  methods: {
    async downloadFile () {
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = this.file.url;
      link.click();
    },
    openRemoveModal(){
        this.$emit('delete', this.file.id);
    },
    sendFile(){
        this.$emit('sendFile', this.file.id);
        this.show_send = false;
    }
  },
  components: {
    'wc-confirm-dialog': WCConfirmDialog
  }
}
</script>